/**
 * @file The dialog component
 * @author Heino Lenting
 */
import { keyCodes } from '../../base/helpers/key-codes';
import { DialogService } from '../../core/dialog.service';
/**
 * Class for the dialog component
 */
var DialogComponent = /** @class */ (function () {
    /**
     * Constructs a DialogComponent
     */
    function DialogComponent(dialogService) {
        this.dialogService = dialogService;
    }
    /**
     * Handles the 'ok' action
     */
    DialogComponent.prototype.ok = function () {
        this.dialogService.next(true);
    };
    /**
     * Handles the 'cancel' action
     */
    DialogComponent.prototype.cancel = function () {
        this.dialogService.next(false);
    };
    /**
     * Get access to the subject of the dialog
     * @returns The subject of the dialog
     */
    DialogComponent.prototype.getSubject = function () {
        return this.dialogService.getSubject();
    };
    /**
     * Get access to the message of the dialog
     * @returns The message of the dialog
     */
    DialogComponent.prototype.getMessage = function () {
        return this.dialogService.getMessage();
    };
    /**
     * Get the button text
     * @returns The text of the button
     */
    DialogComponent.prototype.getButtonText = function () {
        return this.dialogService.getButtonText();
    };
    /**
     * Is there a dialog in the service
     * @returns Returns if a dialog exists
     */
    DialogComponent.prototype.hasDialog = function () {
        return this.dialogService.hasDialog();
    };
    /**
     * Listener for global key down events
     * @param $event The event
     */
    DialogComponent.prototype.keyDown = function (event) {
        /**
        * Controleren of we hier out-zone kunnen gebruiken.
        * Eventueel this.changeDetector.detectChanges() erbij implementeren
        * Als het niet werkt toch geen out-zone gebruiken.
        * Jammer maar dan op dit punt geen performance verbetering.
        */
        // Check for enters
        if (event.keyCode === keyCodes['enter']) {
            this.ok();
        }
    };
    return DialogComponent;
}());
export { DialogComponent };
